import type { SVGProps } from 'react';

interface PublishIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function PublishIcon({ className, ...props }: PublishIconProps) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 3.5 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M6.86621 6.1582L12.4053 11.543L12.5195 11.6533L12.4053 11.7637L11.3994 12.7422L11.291 12.8467L11.1836 12.7422L7.625 9.28223V17.5H5.89453V9.28223L2.33496 12.7422L2.22852 12.8467L2.12012 12.7422L1.11426 11.7637L1 11.6533L1.11426 11.543L6.65234 6.1582L6.75977 6.05371L6.86621 6.1582ZM12.2979 5.3457H1.2207V3.5H12.2979V5.3457Z"
        fill="currentColor"
      />
    </svg>
  );
}
